export enum HTTPErrorCode {
  NotFound = "NotFound",

  NotAuthorized = "NotAuthorized",
  NotAuthenticated = "NotAuthenticated",
  WrongOrg = "WrongOrg",
  NoOrgs = "NoOrgs",
}

export enum GQLErrorCode {
  NotAuthorizedFeature = "NotAuthorizedFeature",
  NotAuthorizeParameter = "NotAuthorizeParameter",
  BadRequest = "BadRequest",
  InternalServerError = "InternalServerError",
}

export enum SchedulingError {
  RaceCondition = 'RACE_CONDTION'
}

export enum AvailabilityError {
  RaceCondition = 'RACE_CONDTION'
}

